import { render, staticRenderFns } from "./article.html?vue&type=template&id=37fd05a8&scoped=true&external"
import script from "./article.js?vue&type=script&lang=js&external"
export * from "./article.js?vue&type=script&lang=js&external"
import style0 from "./article.scss?vue&type=style&index=0&id=37fd05a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd05a8",
  null
  
)

export default component.exports